import { MULTIMEDIA_TYPES, QUESTION_TYPE } from '@/utils/constants';
import * as yup from 'yup';

export const playTypeRead_Schema = (supportedFormats: string[]) => yup.object({
  description: yup.string().required('Descripción es requerida'),
  multimediaTypeId:  yup.string().nullable(),
  fileMultimedia: yup
      .mixed()
      .nullable()
      .when(['urlMultimedia', 'multimediaTypeId'], {
        is: (urlMultimedia: any, multimediaTypeId: number) =>
            !urlMultimedia && multimediaTypeId && multimediaTypeId != MULTIMEDIA_TYPES.LINK,
        then: (schema) => schema
          .required('Archivo multimedia es requerido')
          .test('fileSize', 'La imagen no debe pesar más de 2MB', (value: any) => {
            if (!value) return false;
            return value.size <= 2 * 1024 * 1024; // 2MB max
          })
          .test('fileType', 'Formato del archivo no es válido', (value: any) => {
            if (!value) return false;
            return supportedFormats.includes(value.type);
          }),
        otherwise: (schema) => schema.notRequired(),
      }),
  link: yup
    .string()
    .when('multimediaTypeId', {
      is: (multimediaTypeId: number) => multimediaTypeId == MULTIMEDIA_TYPES.LINK,
      then: (schema) =>
        schema
          .required('El enlace es requerido')
          .url('Debe ser un enlace válido'),
      otherwise: (schema) => schema.notRequired().nullable(),
    }),
  steps: yup
    .string()
    .when('multimediaTypeId', {
      is: (multimediaTypeId: number) => multimediaTypeId == MULTIMEDIA_TYPES.LINK,
      then: (schema) =>
        schema
          .required('El texto del enlace es requerido') ,
      otherwise: (schema) => schema.notRequired().nullable(),
    }),
});   

export const playTypeQuestion_Schema = (supportedFormats: string[]) => yup.object({
  questionTypeId: yup.string().required('Tipo de Pregunta es requerido'),
  sentence: yup.string().required('Enunciado de la Pregunta es requerido'), 
  multimediaTypeId: yup.string().nullable(),  
  fileMultimedia: yup
    .mixed()
    .nullable()
    .when(['urlMultimedia', 'multimediaTypeId'], {
      is: (urlMultimedia: any, multimediaTypeId: number) =>
            !urlMultimedia && multimediaTypeId && multimediaTypeId != MULTIMEDIA_TYPES.LINK,
      then: (schema) => schema
        .required('Archivo multimedia es requerido')
        .test('fileSize', 'La imagen no debe pesar más de 2MB', (value: any) => {
          if (!value) return false;
          return value.size <= 2 * 1024 * 1024; // 2MB max
        })
        .test('fileType', 'Formato del archivo no es válido', (value: any) => {
          if (!value) return false;
          return supportedFormats.includes(value.type);
        }),
      otherwise: (schema) => schema.notRequired(),
    }),
  link: yup
    .string()
    .when('multimediaTypeId', {
      is: (multimediaTypeId: number) => multimediaTypeId == MULTIMEDIA_TYPES.LINK,
      then: (schema) =>
        schema
          .required('El enlace es requerido')
          .url('Debe ser un enlace válido'),
      otherwise: (schema) => schema.notRequired().nullable(),
    }),
  steps: yup
    .string()
    .when('multimediaTypeId', {
      is: (multimediaTypeId: number) => multimediaTypeId == MULTIMEDIA_TYPES.LINK,
      then: (schema) =>
        schema
          .required('El texto del enlace es requerido') ,
      otherwise: (schema) => schema.notRequired().nullable(),
    }),
  questionOptions: yup.mixed().when('questionTypeId', ([questionTypeId]) => {
      if (questionTypeId === '2') {
        return yup
          .array()
          .min(1, 'Debe agregar al menos una opción.')
          .of(
            yup.object({
              id: yup.number().nullable(),
              option: yup.string().required('La opción es requerida.'),
              isCorrect: yup.boolean().required()  // <-- make sure we have isCorrect
            })
          )
          .test(
            'at-least-one-correct',
            'Debe marcar al menos una opción como correcta.',
            (value) => {
              if (!value) return false;
              return value.some((item: any) => item.isCorrect === true);
            }
          );
      }
      return yup.array().notRequired();
    }),
  answer: yup.string().when("questionTypeId", {
      is: (val: number) => val == QUESTION_TYPE.SEMIOPEN, // condition
      then: (schema) => schema.required("Respuesta es requerida"),
      otherwise: (schema) => schema.notRequired(),
    }),

});


export const questionOption_Schema = yup.object().shape({
  questionOptionText: yup
    .string()
    .required('*La respuesta es requerida.')   // required message
    .min(1, '*Debe tener al menos 3 caracteres.') // optional: minimum length
    .max(5000, '*Máximo 5000 caracteres.')         // optional: maximum length
});

